import * as React from "react";
import classnames from "classnames";
import { motion } from "motion/react";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                   */
const animations = {
  expanded: {
    height: "auto",
    opacity: 1,
    transition: {
      ease: [0.08, 0.82, 0.17, 1],
      duration: 0.3
    },
    overflow: "hidden",
    display: "block"
  },
  collapsed: {
    height: "0",
    opacity: 0,
    transition: {
      ease: [0.08, 0.82, 0.17, 1],
      duration: 0.3
    },
    overflow: "hidden"
  }
};
const AccordionItem = ({
  id,
  label,
  className,
  children,
  onClick,
  headingLevel = "h2",
  expanded = false,
  variant = "normal",
  fullWidth,
  icon,
  headerComponent
}) => {
  const [isExpanded, setIsExpanded] = React.useState(expanded);
  const focusState = React.useState(false);
  const setHasFocus = focusState[1];
  const handleClick = React.useCallback(() => {
    setIsExpanded((expanded2) => {
      onClick && onClick(!expanded2);
      return !expanded2;
    });
  }, []);
  const handleFocus = React.useCallback(() => setHasFocus(true), []);
  const handleBlur = React.useCallback(() => setHasFocus(false), []);
  React.useEffect(() => {
    if (expanded !== isExpanded) {
      setIsExpanded(expanded);
    }
  }, [expanded]);
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      "data-t": "accordion-item",
      className: classnames(className, "accordion-item", {
        [`accordion-item--${variant}`]: variant
      })
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        id: `${id}-control`,
        className: classnames("accordion-item__head", {
          [`${className}__head`]: className,
          "accordion-item__head--full-width": fullWidth,
          "accordion-item__head--with-icon": icon
        }),
        "aria-label": label,
        "aria-controls": id,
        "aria-expanded": isExpanded,
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur
      },
      headerComponent && headerComponent,
      icon && /* @__PURE__ */ React.createElement(Icon, { name: icon, className: "accordion-item__icon", height: 32, width: 32 }),
      label.length ? /* @__PURE__ */ React.createElement(
        Heading,
        {
          component: headingLevel,
          className: classnames("accordion-item__label", { [`${className}__label`]: className }),
          variant: "smallest"
        },
        label
      ) : null,
      /* @__PURE__ */ React.createElement(
        Icon,
        {
          name: "chevron-down",
          className: classnames("accordion-item__chevron-icon", {
            [`${className}__chevron-icon`]: className
          }),
          height: 32,
          width: 32
        }
      )
    ),
    /* @__PURE__ */ React.createElement(
      motion.div,
      {
        id,
        className: classnames("accordion-item__body", {
          [`${className}__body`]: className,
          "accordion-item__body--full-width": fullWidth
        }),
        "aria-labelledby": `${id}-control`,
        "aria-hidden": !isExpanded,
        initial: animations.collapsed,
        animate: isExpanded ? animations.expanded : animations.collapsed,
        ...!isExpanded ? { inert: "" } : {}
      },
      children
    )
  );
};
export {
  AccordionItem,
  AccordionItem as default
};
//# sourceMappingURL=AccordionItem.js.map
